type AddHandlePlusIconProps = {
	className?: string;
	/** Default tuned for the inner dashed frame. */
	size?: number;
};

/**
 * Thin stroke plus, optically centered (SVG viewBox + round caps).
 * Color: teal per product (screenshot shows a blue plus on similar chrome).
 */
export function AddHandlePlusIcon({ className, size = 20 }: AddHandlePlusIconProps) {
	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			aria-hidden
			focusable={false}
			style={{
				display: "block",
				flexShrink: 0,
				pointerEvents: "none",
				color: "#3872DD",
			}}
		>
			<path
				d="M12 5v14M5 12h14"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
			/>
		</svg>
	);
}
